import React from 'react';
import { Button } from 'antd';
import { ModalContent } from 'common/components';
import { useAppDispatch, useAppSelector } from 'app/store/store.hooks';
import { setUiChangeRewardConfirmModal } from 'app/store/reducers/ui.reducer';
import { IBitecoinRewardModel } from 'entities/Bitecoin/Bitecoin.models';

interface IComponentProps {
  onContinue(reward: IBitecoinRewardModel): void;
}

export const ChangeRewardConfirmModal: React.FC<IComponentProps> = (props) => {
  const dispatch = useAppDispatch();
  const { onContinue } = props;
  const { uiChangeRewardConfirmModal } = useAppSelector((state) => state.ui);
  const { isVisible, rewardItem } = uiChangeRewardConfirmModal || {};

  const closeUiAddToBagConfirmModal = () => {
    dispatch(setUiChangeRewardConfirmModal({ isVisible: false }));
  };

  const submit = () => {
    rewardItem && onContinue(rewardItem);
    closeUiAddToBagConfirmModal();
  };

  return (
    <ModalContent
      header="Change your reward?"
      subHeader="You already have a promo code or reward applied in your bag. Redeeming a new reward will replace it. 
Do you want to proceed?"
      close={closeUiAddToBagConfirmModal}
      visible={!!isVisible}
    >
      <Button size="large" block className="btn mb-7" type="primary" onClick={submit}>
        Apply new reward
      </Button>
      <Button size="large" block className="btn" onClick={closeUiAddToBagConfirmModal}>
        Cancel
      </Button>
    </ModalContent>
  );
};
